export const orgSelectBundle = {
  header: {
    title: {
      ko: "수도 사업자 관리 포털",
      en: "Water Utility MGMT Portal",
      es: "Portal de gestión de servicios de agua"
    },
    subtitle: {
      ko: "운영 중인 수도 사업자를 검색하고 관리하세요.",
      en: "Search and manage operating water utilities.",
      es: "Busque y gestione los servicios de agua en operación."
    }
  },
  filter: {
    categoryPlaceholder: { ko: "분류 선택", en: "Select Category", es: "Seleccionar categoría" },
    inputPlaceholder: {
      ko: "수도 사업자명으로 검색",
      en: "Search by Utility Name",
      es: "Buscar por nombre de servicio"
    },
    searchButton: { ko: "검색", en: "Search", es: "Buscar" },
    all: { ko: "전체", en: "All", es: "Todo" },
    reset: { ko: "초기화", en: "Reset", es: "Restablecer" },
    apply: { ko: "적용", en: "Apply", es: "Aplicar" },
    categories: {
      국내: { ko: "국내", en: "Domestic", es: "Nacional" },
      국외: { ko: "국외", en: "Overseas", es: "Internacional" }
    }
  },
  favorites: { ko: "즐겨찾기", en: "Favorites", es: "Favoritos" },
  empty: {
    defaultTitle: {
      ko: "지역을 선택하거나 수도 사업자명을 검색해주세요.",
      en: "Please select a region or search by utility name.",
      es: "Seleccione una región o busque por nombre de servicio de agua."
    },
    noResult: {
      ko: "조건에 맞는 사업자가 없습니다.",
      en: "No utilities found matching the conditions.",
      es: "No se encontraron servicios que coincidan con las condiciones."
    },
    resetLink: { ko: "필터 초기화하기", en: "Reset Filters", es: "Restablecer filtros" }
  }
}
